

























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { GradMap } from '@gruppe-adler/maps-frontend-utils/lib/mapbox';

import GradCursorControl from '@/CursorControl';

@Component
export default class MapVue extends Vue {
    @Prop({ default: '' }) private mapName!: string;
    private map: GradMap|null = null;
    private error: any|null = null;
    private mapNotFound = false;

    private mounted() {
        this.map = new GradMap(this.mapName, { container: this.$refs.map as HTMLDivElement, loadElevation: true });

        this.map.on('grad-load', ({ target }: { target: GradMap }) => {
            target.addControl(new GradCursorControl(), 'top-right');
        });

        this.map.on('error', err => {
            this.error = err;
            console.error(err);
        });

        this.map.on('error:mapnotfound', () => {
            this.mapNotFound = true;
        });
    }

    /**
     * Toggle sat layer on/off
     */
    private toggleSat() {
        if (this.map === null) return;

        this.map.satShown = !this.map.satShown;
    }

    private toggleGrid() {
        if (this.map === null) return;

        this.map.gridShown = !this.map.gridShown;
    }

    private get satShown(): boolean {
        if (this.map === null) return false;
        return this.map.satShown;
    }

    private get gridShown(): boolean {
        if (this.map === null) return false;
        return this.map.gridShown;
    }

    private get worldSize(): number {
        if (this.map === null) return 0;

        return (this.map.armaMapMetaData || { worldSize: 0 }).worldSize;
    }
}
